<template>
  <router-link :to="{ name: 'wineDetail', params: { wineId: id } }" class="c-wineitem grey darken-2">
      <img class="c-wineitem__label" :src="src"/>
      <div class="c-wineitem__color" :class="`c-wineitem__color-${color}`"></div>
      <div class="c-wineitem__identification">
        <div class="c-wineitem__name">{{ name }}</div>
        <div class="c-wineitem__producer">{{ producer }}</div>
      </div>
      <div class="c-wineitem__stats">
        <span class="c-wineitem__stats__item">
          <img class="c-wineitem__stats__symbol" src="@/assets/euro-icon.png"/>
          <span class="c-wineitem__stats__value">{{ revenue | toFixed(0) }}</span>
        </span>
        <span class="c-wineitem__stats__item">
          <img class="c-wineitem__stats__symbol" src="@/assets/L-white-icon.png"/>
          <span class="c-wineitem__stats__value">{{ (volume / 100) | toFixed(1) }}</span>
        </span>
      </div>
  </router-link>
</template>

<script>
import { toFixed } from '@/filters';


export default {
  name: 'WineItem',

  props: {
    id: Number,
    src: String,
    name: String,
    producer: String,
    color: String,
    revenue: Number,
    volume: Number
  },

  filters: {
    toFixed
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.c-wineitem {
  display: block;
  position: relative;
  height: 80px;
  color: white;

  &__label {
    position: absolute;
    top: 0;
    left: 0;
    width: 80px;
    height: 80px;
    object-fit: cover;
  }

  &__color {
    position: absolute;
    top: 0;
    left: 80px;
    width: 10px;
    height: 100%;

    &-red {
      background-color: $wine-red;
    }

    &-rose {
      background-color: $wine-rose;
    }

    &-white {
      background-color: $wine-white;
    }
  }

  &__identification {
    position: absolute;
    top: 0;
    left: 90px;
    padding: 10px 0 0 10px;

    text-align: left;
  }

  &__name {
    font-size: 16px;
    font-weight: bold;
    text-transform: capitalize;
  }

  &__producer {
    font-size: 12px;
    text-transform: capitalize;
  }

  &__stats {
    position: absolute;
    top: 15px;
    right: 0;
    margin: 10px 10px 0 0;

    &__item {
      margin: 0 10px 0 10px;
    }

    &__symbol {
    height: 30px;
    }

    &__value {
      position: relative;
      top: -15px;
    }
  }
}
</style>
